var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 12C6 15.0976 8.16409 17 10.125 17C11.4144 17 13.8616 16.3308 16.0242 15.0669C17.0704 14.4554 17.884 13.7982 18.403 13.1817C18.9238 12.5632 19 12.1718 19 12C19 11.8282 18.9238 11.4367 18.403 10.8183C17.884 10.2018 17.0704 9.54461 16.0242 8.93316C13.8616 7.66913 11.4144 7 10.125 7C8.16409 7 6 8.90242 6 12ZM3 12C3 16.4183 6.18997 20 10.125 20C14.0601 20 22 16.4183 22 12C22 7.58171 14.0601 4 10.125 4C6.18997 4 3 7.58171 3 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowEgg);
export default __webpack_public_path__ + "static/media/arrow-egg.051f2380f919c47e619cf89193d9cfb4.svg";
export { ForwardRef as ReactComponent };